export const APP_TITLES = {
  explorer: "My Computer",
  writing: "Blog",
  wiki: "Wikipedia",
  terminal: "Command Prompt",
  search: "Search",
  recycle: "Recycle Bin",
  archive: "Personal System Restore",
  notes: "Notes",
  monitor: "System Monitor",
  readme: "README.TXT - TextPad",
  reader: "Document",
  help: "Help",
  run: "Run",
  properties: "Properties",
  browser: "Internet Explorer",
  photos: "Photo Album",
  mail: "Inbox - Mail",
  calendar: "Calendar",
  media: "Windows Media Player",
  network: "My Network Places",
  control: "Control Panel",
  minesweeper: "Minesweeper",
  minecraft: "Minecraft",
  paint: "Paint",
  calculator: "Calculator",
  piano: "Piano",
  maths: "Arithmetic",
  "beat-maker": "DJ",
  chess: "Chess",
  "dx-ball": "DX-Ball",
  trust: "The Evolution of Trust",
  guestbook: "Guestbook",
  interests: "My Interests",
  socials: "Socials",
  messenger: "Messenger",
  conversation: "Conversation",
  roblox: "ROBLOX",
  youtube: "YouTube",
  blackjack: "Blackjack",
  sticky: "Sticky Notes",
  weather: "Weather",
  inspect: "DOM Inspector",
  shutdown: "Turn off computer"
};

export const TERMINAL_MENU_HELP = "help     shows this command list\ndir      lists files\ncd       changes folder\ntype     reads a file\nopen     opens a file or app\nsearch   searches my archive\ntree     shows folders\ncls      clears the screen";

export const APP_ICONS = {
  explorer: "computer", writing: "document", wiki: "wiki", terminal: "terminal",
  search: "search", recycle: "recycle", archive: "archive-xp", notes: "notepad",
  minesweeper: "minesweeper", minecraft: "minecraft",
  paint: "paint-xp", calculator: "calculator", piano: "piano-xp", maths: "maths-xp",
  "beat-maker": "dj-xp", chess: "chess", "dx-ball": "dx-ball", trust: "trust",
  guestbook: "guestbook", interests: "document", socials: "socials-xp",
  messenger: "messenger-xp", conversation: "messenger-xp", roblox: "roblox-icon-2012",
  youtube: "youtube-2010", blackjack: "blackjack-xp", sticky: "sticky-xp",
  weather: "weather-xp", monitor: "monitor", readme: "document", reader: "document",
  help: "help", run: "run", properties: "properties", browser: "browser-xp",
  photos: "photo", mail: "mail", calendar: "calendar", media: "media",
  network: "network", control: "control-panel-xp", inspect: "properties",
  shutdown: "shutdown-xp"
};

// Keep externally hosted games framed as game surfaces, without a site-made
// launch card or surrounding website content.
export const REMOTE_GAMES = Object.freeze({
  trust: {
    title: "The Evolution of Trust",
    src: "/static/winxp/games/trust/index.html?v13"
  }
});

export const GAME_ICON_ASSETS = Object.freeze({
  "dx-ball": "/static/winxp/icons/dxball-daedalOS.webp",
  photo: "/static/winxp/icons/photos-user.png",
  "dj-xp": "/static/winxp/icons/dj-record-transparent.png",
  chess: "/static/winxp/icons/chess-user.png",
  "sticky-xp": "/static/winxp/icons/sticky-notes-user.png",
  trust: "/static/winxp/icons/evolution-of-trust.png",
  "socials-xp": "/static/winxp/icons/socials-globe-ring.png",
  help: "/static/winxp/icons/help-compass-user.png",
  run: "/static/winxp/icons/run-user.png",
  "control-panel-xp": "/static/winxp/icons/control-panel-user.png",
  "weather-xp": "/static/winxp/icons/weather-cloud-sun-user.png",
  minesweeper: "/static/winxp/icons/minesweeper-mine-user.png",
  "my-documents-xp": "/static/winxp/icons/my-documents-xp.png",
  "pacman-xp": "/static/winxp/icons/pacman-custom.png",
  "soundboard-xp": "/static/winxp/icons/soundboard-xp.png"
});

// Shared by Website statistics and System Monitor so the two views cannot
// drift apart.
export const SITE_STATS = Object.freeze({
  visibleWords: 23463,
  sourceLines: 23920,
  trackedFiles: 7513,
  siteSize: "268 MB",
  attachments: 594,
  timeSpent: 542,
  revisions: 265,
  posts: 1,
  collections: 25
});

export const computerWindowTitle = title => `${title} | Khalid's Computer`;

// Taskbar buttons use the app name; the full suffix belongs in window chrome.
export const taskbarLabel = title => String(title || "")
  .replace(/\s*\|\s*Khalid's Computer\s*$/, "");
